import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { isResponseError } from '@/src/components/project/Inbox2/api/config';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { showToast } from '@/src/globalFunction';

import useSyncInboxEntry from '../../../../../useSyncInboxEntry';
import { useValidateActionResponse } from '../../../../../useValidateActionResponse';
import { useMarkRead } from '../../../../api/markReadEmail';
import { useInbox } from '@/src/components/project/Inbox2/store/inbox.store';

type MarkReadEmailProps = {
  inboxEntryId: number;
  emailId: number;
  isRead: boolean;
};

const MarkReadEmail = ({ inboxEntryId, emailId, isRead }: MarkReadEmailProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const markReadMutation = useMarkRead({ projectId, inboxEntryId, emailId });
  const syncInboxEntry = useSyncInboxEntry();
  const label = isRead ? 'unread' : 'read';
  const { confirmRefreshModal } = useValidateActionResponse({
    responseError: isResponseError(markReadMutation.data) ? markReadMutation.data : null,
  });

  const { setIsMarkReadClicked } = useInbox();

  useEffect(() => {
    setIsMarkReadClicked(markReadMutation.isLoading);
  }, [markReadMutation.isLoading, setIsMarkReadClicked]);

  // Toggle action
  const handleClick = async () => {
    const response = await markReadMutation.mutateAsync({
      projectId,
      inboxEntryId,
      emailId,
      read: !isRead,
    });

    if (isResponseError(response)) {
      return;
    }

    syncInboxEntry(response.data['inbox-entry']);
    showToast('success', `Email successfully marked as ${label}.`);
  };

  return (
    <React.Fragment>
      <ActionButton
        id={'read_email'}
        onClick={handleClick}
        label={`Mark as ${label}`}
        className={clsx('tw-w-full', 'tw-justify-between')}
        icon={ICONS.email_read({
          fillClassName: 'tw-fill-cfo-black group-hover:tw-fill-cfo-blue-600',
        })}
      />
      {confirmRefreshModal}
    </React.Fragment>
  );
};

export default MarkReadEmail;
